import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { DBLegacyExamMarkingRequestSchema, LegacyExamMarkingRequestSchema } from './schemas';

export const LegacyExamMarkingRequestCodecConfig: TransformerConfig<
  typeof LegacyExamMarkingRequestSchema,
  typeof DBLegacyExamMarkingRequestSchema
> = {
  name: 'LegacyExamMarkingRequest',
  clientSchema: LegacyExamMarkingRequestSchema,
  dbSchema: DBLegacyExamMarkingRequestSchema,
  transformers: [],
};

export const encodeLegacyExamMarkingRequestToDb = createEncodeToDbFn(
  LegacyExamMarkingRequestCodecConfig
);
export const decodeLegacyExamMarkingRequestFromDb = createDecodeFromDbFn(
  LegacyExamMarkingRequestCodecConfig
);
